<template>
    <div>
      <loading :active.sync="loader.isLoading" :can-cancel="loader.canCancel" :is-full-page="loader.fullPage" :color="loader.color" :height="loader.height" :width="loader.width" :background-color="loader.backgroundColor" :loader="loader.loader"></loading>
      <div class="row">
        <div class="col-md-12">
          <div class="top-list-toolbar">
            <div>
              <h4 class="text-primary">Adjust</h4>
              <ol class="breadcrumb breadcrumb-card-header">
                <li class="breadcrumb-item">
                  <a href="javascript:void(0);" @click="backParent">Adjust</a>
                </li>
                <li class="breadcrumb-item active">
                  <span v-if="inventory.id === null">New</span>
                  <span v-else>{{ inventory.inventory_no }}</span>
                </li>
              </ol>
              <button type="button" @click="backParent" class="btn btn-sm btn-hard-outline-primary pull-left"><i class="fa fa-reply" aria-hidden="true"></i> Back</button>
              <button class="btn btn-success btn-sm pull-left dropdown-toggle" type="button" id="printsales" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false" v-show="inventory.id !== null">Action</button>
              <div class="dropdown-menu" aria-labelledby="printsales">
                <a type="button" @click="setCOGS" class="dropdown-item" href="javascript:void(0)" v-show="inventory.id !== null">Set COGS</a>
                <a type="button" @click="setCOGSAll('reply')" class="dropdown-item" href="javascript:void(0)" v-show="inventory.id !== null">Set COGS All</a>
                <a type="button" @click="approveInventory" class="dropdown-item" href="javascript:void(0)" v-show="inventory.id !== null">Approve</a>
                <a type="button" @click="setJournalAdjust('reply')" class="dropdown-item" href="javascript:void(0)" v-show="inventory.id !== null">Set Journal</a>
                <a type="button" @click="deleteAdjust" class="dropdown-item" href="javascript:void(0)" v-show="inventory.id !== null">Delete</a>
              </div>
              <button type="button" @click="updateInventory('reply')" class="btn btn-sm btn-soft-primary pull-left" v-show="inventory.id !== null"><i class="fa fa-check" aria-hidden="true"></i> Update</button>
              <!-- <button type="button" @click="updateDraftInventory" class="btn btn-sm btn-soft-primary pull-left" v-show="inventory.id !== null"><i class="fa fa-check" aria-hidden="true"></i> Update Draft</button> -->
              <button type="button" @click="saveInventory" class="btn btn-sm btn-soft-primary pull-left" v-show="inventory.id == null"><i class="fa fa-check" aria-hidden="true"></i> Save</button>
              <button type="button" @click="validate" class="btn btn-sm btn-soft-primary pull-left"><i class="fa fa-check" aria-hidden="true"></i> Validate</button>
              <button type="button" class="btn btn-sm btn-warning pull-right" data-toggle="modal" data-target="#modalRequestEdit" data-backdrop="static" data-keyboard="false"><i class="fa fa-reply" aria-hidden="true"></i> Request Edit</button>
            </div>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="card card-list">
          <div class="card-header">
            <h5 class="text-primary">
              <span v-if="inventory.id !== null">{{ inventory.inventory_no }}</span>
              <span v-else>New</span>
              <button type="button" class="btn btn-sm btn-hard-outline-primary pull-right mb-2" data-toggle="modal" data-target="#modalInventoryDetail" data-backdrop="static" data-keyboard="false" @click="setSetting">Setting</button>
            </h5>
          </div>
          <div class="card-body">
            <div class="alert alert-danger alert-dismissible fade show" role="alert" v-if="alert.length > 0">
              <ul v-for="(a, index) in alert" :key="index">
                <li v-html="a"></li>
              </ul>
            </div>
            <div class="row">
              <div class="col-md-6">
                <dl class="row dl-custom font-12">
                  <dt class="col-md-5">Date</dt>
                  <dd class="col-md-7">
                    <span v-if="inventory.lock === true"><b>{{ inventory.inventory_date | dateFormat('DD/MM/YYYY') }}</b></span>
                    <span v-else>
                      <datetime v-model="inventory.inventory_date" format="dd/MM/yyyy" class="form-control" value-zone="local" zone="local" v-if="authUser.permissions.sale_backdate"></datetime>
                      <datetime v-model="inventory.inventory_date" format="dd/MM/yyyy" class="form-control" value-zone="local" zone="local" @input="checkDate" v-else :disabled="inventory.lock"></datetime>
                    </span>
                  </dd>

                  <dt class="col-md-5">Type</dt>
                  <dd class="col-md-7">
                    <select v-model="inventory.type_id" class="form-control" :disabled="inventory.lock">
                      <option v-for="t in itList" :key="t.id" :value="t.id">{{ t.name }}</option>
                    </select>
                  </dd>
                </dl>
              </div>
              <div class="col-md-6">
                <dl class="row dl-custom">
                  <dt class="col-md-5">Company</dt>
                  <dd class="col-md-7">
                    <select class="form-control" v-model="inventory.company_no" :disabled="inventory.lock">
                      <option v-for="c in companyList" :key="c.id" :value="c.company_no">{{ c.name }}</option>
                    </select>
                  </dd>
                  <dt class="col-md-5">Warehouse</dt>
                  <dd class="col-md-7">
                    <span v-if="inventory.lock">{{ inventory.warehouse }}</span>
                    <select v-else v-model="inventory.warehouse_no" id="warehouse_no" class="form-control form-control-lite" :disabled="inventory.lock">
                      <option value="">---</option>
                      <option v-for="w in warehouseList" :key="w.id" :value="w.warehouse_no"><b>[{{ w.warehouse_no }}]</b> {{ w.name }}</option>
                    </select>
                  </dd>
                  <dt class="col-md-5">Vendor No.</dt>
                  <dd class="col-md-7">
                    <v-select class="vsc-custom" :options="vendorSelect" :reduce="vendor => vendor.meta.code" label="vendor" v-model="inventory.vendor_no" :disabled="inventory.lock"/>
                  </dd>
                  <dt class="col-md-5">Notes:</dt>
                  <dd class="col-md-7">
                    <textarea rows="3" class="form-control" v-model="inventory.notes" :disabled="inventory.lock"></textarea>
                  </dd>
                </dl>
              </div>
            </div>
            <div class="row">
              <div class="col-md-12">
                <ul class="nav nav-tabs nav-bordered">
                  <li class="nav-item">
                    <a href="#general" data-toggle="tab" aria-expanded="false" class="nav-link active">
                      Data
                    </a>
                  </li>
                  <li class="nav-item">
                    <a href="#journal" data-toggle="tab" aria-expanded="false" class="nav-link">
                      Journal
                    </a>
                  </li>
                </ul>
                <div class="tab-content">
                  <div class="tab-pane active" id="general">
                    <div class="table-responsive">
                      <table class="table table-sm table-item table-striped">
                        <thead>
                          <th>Product No.</th>
                          <th>Qty</th>
                          <th>UoM</th>
                          <th>Harga</th>
                          <!-- <th>Serial Number</th> -->
                          <!-- <th>Serial Number 2</th> -->
                          <!-- <th>Vendor</th> -->
                          <th>#</th>
                        </thead>
                        <tbody>
                          <tr v-for="(p, index) in getDetail" :key="p.id">
                            <td>
                              <v-select :options="productselect" :reduce="product => product.meta.code" label="product" v-model="p.product_no" @input="setProduct(index)" :disabled="inventory.lock"/>
                            </td>
                            <!-- <td><b>{{ p.product_sku }}</b></td> -->
                            <!-- <td><input type="text" v-model="p.product" class="form-control" disabled="disabled"></td> -->
                            <td><input type="text" v-model="p.qty_done" class="form-control" :disabled="inventory.lock"/></td>
                            <td>
                              <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true" v-if="p.uom_id === null"></span>
                              <span v-else>
                                <select v-model="p.uom_id" class="form-control" @input="setUom(index, p.uom_id, $event)" :disabled="inventory.lock">
                                  <option v-for="(u, idx) in p.uomList" :key="idx" :value="u.id">{{ u.name }}</option>
                                </select>
                              </span>
                            </td>
                            <td><input type="text" v-model="p.cost" class="form-control" v-money="money" :disabled="inventory.lock"/></td>
                            <!-- <td><input type="text" v-model="p.serial_number" class="form-control" :disabled="inventory.lock"/></td> -->
                            <!-- <td><input type="text" v-model="p.sec_serial_number" class="form-control" :disabled="inventory.lock"/></td> -->
                            <!-- <td><v-select class="vsc-custom" :options="vendorSelect" :reduce="vendor => vendor.meta.code" label="vendor" v-model="p.vendor_no" :disabled="inventory.lock"/></td> -->
                            <td>
                              <button type="button" class="btn btn-sm btn-soft-outline-danger" @click="remove(index)" v-if="inventory.lock === false">
                                <i class="fa fa-trash"></i>
                              </button>
                              <button type="button" class="btn btn-sm btn-soft-outline-primary" @click="setProduct(index)" v-if="inventory.lock === false">
                                <i class="fa fa-refresh"></i>
                              </button>
                            </td>
                          </tr>
                          <tr>
                            <td>
                              <span @click="addLine" class="link-secondary" v-if="inventory.lock === false">Add Line</span>
                            </td>
                            <td>
                              {{ totalDetailQtyDone }}
                            </td>
                            <td></td>
                            <td>
                              <h5>Total: {{ totalDetailCount }}</h5>
                            </td>
                            <td></td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                  <div class="tab-pane" id="journal">
                    <div class="table-responsive">
                      <table class="table table-sm table-item table-hover table-striped">
                        <thead>
                          <th>Journal Code</th>
                          <th>Date</th>
                          <th>Account Code</th>
                          <th>Remark</th>
                          <th class="text-right">Debit</th>
                          <th class="text-right">Credit</th>
                        </thead>
                        <tbody>
                          <tr v-for="j in inventory.journals" :key="j.id">
                            <td>
                              <span v-if="j.level === 1">
                                <b>{{ j.journal_code }} - {{ j.journal_description }}</b>&nbsp;
                                <span class="badge badge-success" v-if="j.status === 'posted'">{{ j.status }}</span>
                                <span class="badge badge-warning" v-else-if="j.status === 'draft'">{{ j.status }}</span>
                              </span>
                              <span v-else></span>
                            </td>
                            <td>{{ j.journal_date | dateFormat('DD/MM/YYYY') }}</td>
                            <td><b>{{ j.account_code }} {{ j.account }}</b></td>
                            <td>{{ j.remark }}</td>
                            <td class="text-right">
                              <span v-if="j.level === 2">{{ j.debit | currency }}</span>
                              <span v-if="j.level === 3"><b>{{ j.debit | currency }}</b></span>
                              <span v-else></span>
                            </td>
                            <td class="text-right">
                              <span v-if="j.level === 2">{{ j.credit | currency }}</span>
                              <span v-if="j.level === 3"><b>{{ j.credit | currency }}</b></span>
                              <span v-else></span>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                      <!-- <button type="button" class="btn btn-sm btn-success pull-right" @click="postJournal">Post</button> -->
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="card-footer">
          </div>
        </div>
      </div>
      <PurchasingProductModal :idDetail="idDetail" @selectProduct="selectProduct" :type="'regular'"/>
      <InventoryModal :setting="setting" />
      <InventoryPurchasingModal :inventory="inventory" @selectPurchasing="selectPurchasing" @getRequestEdit="getRequestEdit" @getRequestVoid="getRequestVoid" />
      <div class="row justify-content-md-center">
        <div class="col-md-6">
          <h5>Logs:</h5>
          <div class="alert alert-info" role="alert" v-for="l in inventory.logs" :key="l.id">
            <b>{{ l.user }}</b> - {{ l.log_date | dateFormat('DD/MM/YYYY HH:mm:ss') }} <span>"{{ l.description }}"</span>
          </div>
        </div>
      </div>
    </div>
</template>

<script>
import axios from 'axios'
import Loading from 'vue-loading-overlay'
import 'vue-loading-overlay/dist/vue-loading.css'
import { mapState } from 'vuex'
import { accountUrl, inventoryUrl, lockUrl, productUrl, getHeader } from '@/config'
import InventoryModal from '@/components/inventory/InventoryModal.vue'
import PurchasingProductModal from '@/components/purchasing/PurchasingProductModal.vue'
import InventoryPurchasingModal from '@/components/inventory/InventoryPurchasingModal.vue'

export default {
  name: 'AdjustForm',
  props: ['inventory', 'purchasing'],
  components: {
    Loading,
    PurchasingProductModal,
    InventoryModal,
    InventoryPurchasingModal
  },
  created () {
    // Add barcode scan listener and pass the callback function
    console.log('created')
  },
  mounted () {
    this.$barcodeScanner.init(this.onBarcodeScanned)
  },
  destroyed () {
    // Remove listener when component is destroyed
    this.$barcodeScanner.destroy()
  },
  data () {
    return {
      alert: [],
      loader: {
        isLoading: false,
        fullPage: true,
        color: '#007bff',
        canCancel: true,
        height: 128,
        width: 128,
        backgroundColor: '#ffffff',
        loader: 'spinner'
      },
      searchQueryPurchasing: '',
      card1: 'col-md-12',
      card2: 'col-md-4',
      selected: [],
      selectAll: null,
      idDetail: null,
      idPDetail: null,
      product: {
        product_no: null,
        uom_id: null
      },
      setting: {
        product_no: null,
        product: null,
        uom_id: null,
        uomList: null,
        expired_date: null,
        cost: null,
        vendor_no: null
      },
      money: {
        decimal: ',',
        thousands: '.',
        prefix: '',
        suffix: '',
        precision: 2,
        masked: true /* doesn't work with directive */
      }
    }
  },
  computed: {
    ...mapState({
      inventoryTypeList: state => state.inventories.inventoryTypeList,
      warehouseList: state => state.warehouses.warehouseList,
      uomList: state => state.uom.uomList,
      vendorList: state => state.vendors.vendorList,
      authUser: state => state.users.authUser,
      productListSelect: state => state.products.productListSelect,
      companyList: state => state.companies.companyList
    }),
    itList () {
      var list = this.inventoryTypeList.filter(d => d.id === 'adjust' || d.id === 'adjust_decrease' || d.id === 'adjust_manufacture_decrease' || d.id === 'adjust_manufacture')
      return list
    },
    totalPurchasingQty () {
      var sum = 0
      var array = this.inventory.purchasing
      for (let i = 0; i < array.length; i++) {
        var arr = array[i].details.filter(d => {
          for (const name in d) {
            if (d[name] !== null) {
              if (d[name].toString().toLowerCase().indexOf(this.searchQueryPurchasing.toLowerCase()) > -1) {
                return d
              }
            }
          }
        })
        if (arr.length > 0) {
          for (let l = 0; l < arr.length; l++) {
            sum += parseFloat(arr[l].qty)
          }
        }
      }
      return sum
    },
    totalPurchasingQtyDone () {
      var sum = 0
      var array = this.inventory.purchasing
      for (let i = 0; i < array.length; i++) {
        var arr = array[i].details.filter(d => {
          for (const name in d) {
            if (d[name] !== null) {
              if (d[name].toString().toLowerCase().indexOf(this.searchQueryPurchasing.toLowerCase()) > -1) {
                return d
              }
            }
          }
        })
        if (arr.length > 0) {
          for (let l = 0; l < arr.length; l++) {
            sum += parseFloat(arr[l].qty_done)
          }
        }
      }
      return sum
    },
    purchasingDetailList () {
      var array = this.inventory.purchasing
      var loop = []
      if (array.length > 0) {
        for (let i = 0; i < array.length; i++) {
          var arr = array[i].details
          if (arr.length > 0) {
            for (let a = 0; a < arr.length; a++) {
              var obj = {
                id: arr[a].id,
                purchasing_no: array[i].purchasing_no,
                purchasing_date: arr[a].purchasing_date,
                sp_no: array[i].sp_no,
                product_no: arr[a].product_no,
                product: arr[a].product,
                qty: arr[a].qty,
                qty_done: arr[a].qty_done,
                uom_id: arr[a].uom_id
              }
              loop.push(obj)
            }
          }
        }
      }
      return loop.filter(d => {
        for (const name in d) {
          if (d[name] !== null) {
            if (d[name].toString().toLowerCase().indexOf(this.searchQueryPurchasing.toLowerCase()) > -1) {
              return d
            }
          }
        }
      })
    },
    vendorData () {
      var data = this.vendorList.find(d => d.vendor_no === this.inventory.vendor_no)
      var obj = {}
      if (data) {
        obj = data
      } else {
        obj = {
          id: null,
          name: null,
          vendor_no: null,
          type_id: null,
          email: null,
          phone: null,
          mobile: null,
          vat: null,
          address: null,
          city_id: null,
          city: null,
          state_id: null,
          state: null,
          postalcode: null,
          alias: null,
          company_no: null
        }
      }
      return obj
    },
    vendorSelect () {
      var loop = []
      var array = this.vendorList
      for (let i = 0; i < array.length; i++) {
        var obj = {
          vendor: array[i].vendor_no + ' - ' + array[i].name,
          meta: {
            code: array[i].vendor_no
          }
        }
        loop.push(obj)
      }
      return loop
    },
    productselect: function () {
      var loop = []
      var array = this.productListSelect
      for (var x = 0; x < array.length; x++) {
        var obj = {
          product: array[x].product_no + ' - ' + array[x].product_name,
          meta: {
            code: array[x].product_no
          }
        }
        loop.push(obj)
      }
      return loop
    },
    totalDetailCount () {
      return this.inventory.details.length
    },
    totalDetailQtyDemand () {
      var sum = 0
      var array = this.inventory.details
      for (let i = 0; i < array.length; i++) {
        sum += parseInt(array[i].qty_demand)
      }
      return sum
    },
    totalDetailQtyDone () {
      var sum = 0
      var array = this.inventory.details
      for (let i = 0; i < array.length; i++) {
        sum += parseInt(array[i].qty_done)
      }
      return sum
    },
    getLogs: function () {
      return this.inventory.logs.filter(d => d.id !== null)
    },
    getDetail: function () {
      return this.inventory.details
    },
    purchasingDetail: function () {
      return this.purchasing.details
    }
  },
  methods: {
    async deleteAdjust () {
      var array = this.inventory.details
      for (let i = 0; i < array.length; i++) {
        if (typeof array[i].id === 'undefined') {
        } else {
          await axios.delete(inventoryUrl + '/detail/' + array[i].id, { headers: getHeader(), timeout: process.env.VUE_APP_TIMEOUT })
            .then(response => {
              console.log(response)
            })
            .catch(error => {
              console.log(error.response.data)
            })
        }
        var data = {
          date: this.inventory.inventory_date,
          product_no: array[i].product_no,
          type: 'all',
          company_no: null
        }
        await axios.post(productUrl + '/cost/sync', data, { headers: getHeader() })
          .then(response => {
            console.log(response.data.message)
          })
          .catch(error => {
            console.log(error)
            console.log(error.response)
            this.$swal('Error', error.response.data.message, 'error')
            throw error
          })
      }
      await axios.delete(inventoryUrl + '/' + this.inventory.id, { headers: getHeader(), timeout: process.env.VUE_APP_TIMEOUT })
        .then(response => {
          console.log(response.data.message)
          this.$emit('backSaveClicked')
        })
        .catch(error => {
          console.log(error)
          console.log(error.response)
          this.$swal('Error', error.response.data.message, 'error')
        })
    },
    async checkDate () {
      var date1 = new Date()
      date1.setHours(0, 0, 0, 0)
      var date2 = new Date(this.inventory.inventory_date)
      date2.setHours(0, 0, 0, 0)
      var remaining = date2.getTime() - date1.getTime()
      var diffInDay = remaining / (1000 * 3600 * 24)
      console.log('Diff in a day ' + diffInDay)
      if (diffInDay > 0) {
        this.$swal('Error', 'Tanggal tidak boleh lebih dari hari ini (' + diffInDay + ' hari)', 'error')
        this.inventory.inventory_date = date1.toISOString()
      } else if (Math.abs(diffInDay) > 2) {
        this.$swal('Error', 'Tanggal tidak boleh kurang dari 2 hari', 'error')
        this.inventory.inventory_date = date1.toISOString()
      }
    },
    async setJournalAdjust (reply) {
      var obj = {
        id: this.inventory.id
      }
      var resp = {
        error: false,
        message: null
      }
      var url = null
      if (this.inventory.type_id === 'adjust_decrease') {
        // url = inventoryUrl + '/journal-adjust-decrease'
        url = inventoryUrl + '/journal-adjust-manufacture-decrease'
      } else if (this.inventory.type_id === 'adjust') {
        // url = inventoryUrl + '/journal-adjust'
        url = inventoryUrl + '/journal-adjust-manufacture'
      } else if (this.inventory.type_id === 'adjust_manufacture') {
        url = inventoryUrl + '/journal-adjust-manufacture'
      } else if (this.inventory.type_id === 'adjust_manufacture_decrease') {
        url = inventoryUrl + '/journal-adjust-manufacture-decrease'
      }
      console.log(obj)
      console.log(url)
      await axios.post(url, obj, { headers: getHeader(), timeout: process.env.VUE_APP_TIMEOUT })
        .then(response => {
          console.log(response.data.message)
          resp.error = false
          resp.message = response.data.message
        })
        .catch(error => {
          console.log(error)
          console.log(error.response)
          if (reply === 'reply') {
            this.$swal('Error', error.response.data.message, 'error')
            throw error
          }
        })
      if (reply) {
        if (resp.error === false) {
          await this.$swal('Success', resp.message, 'success')
        } else {
          await this.$swal('Error', resp.message, 'error')
        }
      }
    },
    async setUom (index, item, event) {
      var oldValue = item
      console.log('old value ' + oldValue)
      var newValue = event.target.value
      console.log('new value ' + newValue)
      var detail = this.inventory.details[index]
      console.log(detail)
      var detailUom = detail.uomList.find(d => d.id === newValue)
      console.log(detailUom.category)
      // var qtyDone = 0
      // if (detailUom.category === 2) {
      //   qtyDone = parseFloat(detail.qty_done) / parseFloat(detailUom.ratio)
      // } else if (detailUom.category === 1) {
      //   qtyDone = parseFloat(detail.qty_done) * parseFloat(detailUom.ratio)
      // }
      // console.log(qtyDone)
      // detail.qty_done = qtyDone
    },
    async setAccountBegin () {
      if (this.inventory.type_id === 'begin') {
        this.$Progress.start()
        this.loader.isLoading = true
        var array = this.inventory.details.filter(d => d.cost !== '0')
        for (let i = 0; i < array.length; i++) {
          var cost = parseFloat(array[i].cost.replace(/\./g, ''))
          var obj = {
            date: this.inventory.inventory_date,
            company: this.inventory.company_no,
            cost: parseFloat(array[i].qty_done) * cost,
            product_no: array[i].product_no
          }
          await axios.post(accountUrl + '/set-saldo-awal', obj, { headers: getHeader(), timeout: process.env.VUE_APP_TIMEOUT })
            .then(response => {
              console.log(response.data.message)
              this.$Progress.finish()
              this.loader.isLoading = false
            })
            .catch(error => {
              console.log(error.response)
              this.$swal('Error', error.response.data.message, 'error')
              this.$Progress.finish()
              this.loader.isLoading = false
              throw error
            })
        }
        await this.$swal('Success', 'Succes set account "Persediaan"', 'success')
      }
    },
    async setCOGS () {
      this.$Progress.start()
      this.loader.isLoading = true
      var array = this.inventory.details
      for (let i = 0; i < array.length; i++) {
        var data = {
          date: this.inventory.inventory_date,
          product_no: array[i].product_no,
          type: 'inventory',
          company_no: this.inventory.company_no
        }
        console.log(data)
        await axios.post(productUrl + '/cost/sync', data, { headers: getHeader(), timeout: process.env.VUE_APP_TIMEOUT })
          .then(response => {
            console.log('success sync cogs')
            console.log(response.data.data)
          })
          .catch(error => {
            console.log(error.response)
          })
      }
      await this.$swal('Success', 'Success Sync COGS', 'success')
      this.$Progress.finish()
      this.loader.isLoading = false
    },
    async setCOGSAll (reply) {
      this.$Progress.start()
      this.loader.isLoading = true
      var array = this.inventory.details
      for (let i = 0; i < array.length; i++) {
        var data = {
          date: this.inventory.inventory_date,
          product_no: array[i].product_no,
          type: 'all',
          company_no: this.inventory.company_no
        }
        console.log(data)
        await axios.post(productUrl + '/cost/sync', data, { headers: getHeader(), timeout: process.env.VUE_APP_TIMEOUT })
          .then(response => {
            console.log('success sync cogs')
            console.log(response.data.data)
          })
          .catch(error => {
            console.log(error.response)
          })
      }
      await this.$Progress.finish()
      this.loader.isLoading = false
      if (reply === 'reply') {
        await this.$swal('Success', 'Success Sync COGS', 'success')
      }
    },
    selectProductToPurchase (product) {
      this.searchQueryPurchasing = product
      this.card1 = 'col-md-8'
      this.card2 = 'col-md-4'
    },
    removePurchasing (index) {
      this.inventory.purchasing.splice(index, 1)
      this.selectPurchasing(this.inventory.purchasing)
    },
    changeView () {
      if (this.card1 === 'col-md-12') {
        this.card1 = 'col-md-8'
        this.card2 = 'col-md-4'
      } else {
        this.card1 = 'col-md-12'
        this.card2 = null
      }
    },
    selectCheckDetail (index) {
      var detail = this.inventory.details[index]
      if (detail.receive_finish !== true) {
        console.log(detail.qty_demand)
        detail.qty_done = detail.qty_demand
      } else {
        detail.qty_done = 0
      }
    },
    select () {
      this.selected = []
      this.currentPage = 1
      var array = this.inventory.details
      if (!this.selectAll) {
        for (const i in array) {
          array[i].receive_finish = true
          array[i].qty_done = array[i].qty_demand
        }
      } else {
        for (const i in array) {
          array[i].receive_finish = false
          array[i].qty_done = 0
        }
      }
    },
    async setProduct (index) {
      var detail = this.inventory.details[index]
      var product = this.productListSelect.find(d => d.product_no === detail.product_no)
      console.log('Product: ')
      console.log(product)
      detail.product_no = product.product_no
      detail.product = product.product_name
      detail.canBarcode = product.canBarcode
      var body = {
        product_no: detail.product_no
      }
      await axios.post(productUrl + '/uom/list', body, { headers: getHeader(), timeout: process.env.VUE_APP_TIMEOUT })
        .then(response => {
          console.log(response.data.data)
          detail.uomList = response.data.data
          this.inventory.details[index].uom_id = product.uom_id
        })
        .catch(error => {
          console.log(error)
          console.log(error.response)
          this.$swal('Error', error.response.data.message, 'error')
          throw error
        })
      var dataCosts = {
        date: this.inventory.inventory_date,
        product_no: detail.product_no,
        company_no: null
      }
      console.log(dataCosts)
      await axios.post(productUrl + '/cost/product', dataCosts, { headers: getHeader(), timeout: process.env.VUE_APP_TIMEOUT })
        .then(response => {
          console.log(response.data.message)
          const data = response.data.data[0]
          const cost = data.cost_amount
          console.log(cost)
          detail.cost = Number(cost).toFixed(2)
          if (parseFloat(detail.qty_done) === 0) {
            detail.qty_done = 1
          }
        })
        .catch(error => {
          console.log(error)
          console.log(error.response)
        })
    },
    async getRequestEdit (value) {
      var obj = {
        request_by: this.authUser.username,
        lock_no: this.inventory.inventory_no,
        lock_note: value,
        type: 'inventory'
      }
      await axios.post(lockUrl, obj, { headers: getHeader(), timeout: process.env.VUE_APP_TIMEOUT })
        .then(response => {
          this.$swal(
            'Success',
            'Inventory has been request to unlock',
            'success'
          )
          this.$emit('backClicked')
        })
        .catch(error => {
          console.log(error)
        })
    },
    getRequestVoid (value) {
      console.log(value)
    },
    async removeAllDetail () {
      var array = this.inventory.details
      for (let i = 0; i < array.length; i++) {
        if (typeof array[i].id === 'undefined') {
        } else {
          await axios.delete(inventoryUrl + '/detail/' + array[i].id, { headers: getHeader(), timeout: process.env.VUE_APP_TIMEOUT })
            .then(response => {
              console.log(response)
            })
            .catch(error => {
              console.log(error.response.data)
            })
        }
      }
      this.inventory.details = []
    },
    selectPurchasing (value) {
      this.inventory.purchasing = value
      this.removeAllDetail()
      var warehouse = {}
      var company = null
      for (let a = 0; a < value.length; a++) {
        warehouse = this.warehouseList.find(d => d.company_no === value[a].company_no)
        company = value[a].company_no
        var array = value[a].details
        for (let i = 0; i < array.length; i++) {
          var inv = this.inventory.details.find(d => d.product_no === array[i].product_no)
          if (inv) {
            console.log('PRODUCT EXIST: ' + array[i].product_no)
            inv.qty_demand = parseInt(inv.qty_demand) + parseInt(array[i].qty)
          } else {
            var qtyDone = array[i].qty_done === '' || array[i].qty_done === null ? 0 : parseInt(array[i].qty_done)
            var obj = {
              inventory_no: this.inventory.inventory_no,
              qty_demand: parseInt(array[i].qty) - qtyDone,
              qty_done: '0',
              serial_number: null,
              product_no: array[i].product_no,
              product_sku: null,
              warehouse_no: this.inventory.warehouse_no,
              uom_id: array[i].uom_id,
              inventory_date: this.inventory.inventory_date,
              branch_no: this.inventory.branch_no,
              company_no: this.inventory.company_no,
              expired_date: null,
              sec_serial_number: null,
              vendor_no: value.vendor_no,
              canBarcode: array[i].canBarcode,
              receive_finish: false,
              cost: null,
              state: 'create'
            }
            this.inventory.details.push(obj)
          }
        }
      }
      this.inventory.warehouse_no = warehouse ? warehouse.warehouse_no : null
      this.inventory.company_no = company
    },
    getPurchasingId (index) {
      var purch = this.inventory.purchasing[index]
      var payload = {
        purchasing: purch.purchasing_no
      }
      console.log(payload)
      this.$store.dispatch('getPurchasingID', payload)
    },
    getPurchasing () {
      var payload = {
        status: 'order',
        vendor: this.inventory.vendor_no
      }
      this.$store.dispatch('getPurchasingList', payload)
    },
    setSetting: function () {
      this.$store.dispatch('getProductList')
    },
    onBarcodeScanned: function (barcode) {
      var check = this.inventory.details.find(d => d.serial_number === barcode)
      if (typeof check === 'undefined') {
        var obj = {
          inventory_no: null,
          serial_number: barcode,
          sec_serial_number: null,
          product_no: this.setting.product_no,
          product_sku: null,
          product: this.setting.product,
          inventory_date: null,
          canBarcode: false,
          warehouse_no: null,
          branch_no: null,
          company_no: null,
          uom_id: this.setting.uom_id,
          uomList: this.setting.uomList,
          qty_demand: 1,
          qty_done: 1,
          expired_date: this.setting.expired_date,
          cost: this.setting.cost,
          vendor_no: this.setting.vendor_no,
          state: 'create'
        }
        this.inventory.details.push(obj)
        // console.log(window.scrollTop)
        var position = window.pageYOffset || document.documentElement.scrollTop
        var newposition = parseInt(position) + 50
        window.scrollTo(0, newposition)
      }
    },
    async remove (index) {
      var detail = this.inventory.details[index]
      console.log(detail)
      if (detail.state === 'create') {
        this.inventory.details.splice(index, 1)
      } else {
        await this.$swal.fire({
          title: 'Are you sure Delete this?',
          text: "You won't be able to revert this!",
          icon: 'error',
          showCancelButton: true,
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#d33',
          confirmButtonText: 'Yes, delete it!'
        }).then((result) => {
          if (result.value) {
            axios.delete(inventoryUrl + '/detail/' + detail.id, { headers: getHeader(), timeout: process.env.VUE_APP_TIMEOUT })
              .then(response => {
                console.log(response.data.message)
              })
              .catch(error => {
                console.log(error.response)
              })
          }
        })

        await this.inventory.details.splice(index, 1)
        var data = {
          date: this.inventory.inventory_date,
          product_no: detail.product_no,
          type: 'all',
          company_no: this.inventory.company_no
        }
        await axios.post(productUrl + '/cost/sync', data, { headers: getHeader(), timeout: process.env.VUE_APP_TIMEOUT })
          .then(response => {
            console.log(response.data.message)
          })
          .catch(error => {
            console.log(error)
            console.log(error.response)
            this.$swal('Error', error.response.data.message, 'error')
            throw error
          })
      }
    },
    setIdDetail: function (id) {
      this.idDetail = id
    },
    selectProduct: function (data) {
      var snu = false
      if (data.canBarcode === true) {
        snu = false
      } else {
        snu = true
      }
      var inv = this.inventory.details[this.idDetail]
      inv.inventory_no = null
      inv.qty_demand = 1
      inv.qty_done = 1
      inv.serial_number = null
      inv.product_no = data.product_no
      inv.product_sku = data.product_sku
      inv.canBarcode = snu
      inv.product = data.product_name
      inv.warehouse_no = null
      inv.uom_id = data.uom_id
      inv.expired_date = data.expired_date
      inv.uomList = data.uomList
      inv.branch_no = data.branch_no
      inv.cost = data.cost
      inv.vendor_no = this.setting.vendor_no
    },
    addLine: function () {
      var obj = {
        inventory_no: null,
        qty_demand: null,
        qty_done: 1,
        serial_number: null,
        product_no: null,
        product_sku: null,
        warehouse_no: null,
        uom_id: null,
        inventory_date: null,
        branch_no: null,
        company_no: this.inventory.company_no,
        expired_date: null,
        sec_serial_number: null,
        vendor_no: null,
        canBarcode: false,
        cost: '0',
        receive_finish: true,
        uomList: [{
          id: null,
          name: null,
          ratio: '0',
          category: null
        }],
        state: 'create'
      }
      this.inventory.details.push(obj)
    },
    async approveInventory () {
      await this.$Progress.start()
      this.loader.isLoading = true
      var resp = {
        error: false,
        message: null
      }
      this.updateInventory('no reply')
      await axios.get(inventoryUrl + '/approve/' + this.inventory.id, { headers: getHeader(), timeout: process.env.VUE_APP_TIMEOUT })
        .then(response => {
          resp.error = false
          resp.message = response.data.message
        })
        .catch(error => {
          console.log(error)
          console.log(error.response)
          this.$swal('Error', error.response.data.message, 'error')
          throw error
        })
      if (resp.error === false) {
        await this.setCOGSAll('no reply')
        await this.setJournalAdjust('no reply')
        await this.$Progress.finish()
        this.loader.isLoading = false
        await this.$swal('Success', resp.message, 'success')
        await this.$emit('backSaveClicked')
      } else {
        await this.$Progress.finish()
        this.loader.isLoading = false
        await this.$swal('Error', resp.message, 'error')
      }
    },
    async validate () {
      this.alert = []
      window.scrollTo(0, 0)
      var array = this.inventory.details
      for (let i = 0; i < array.length; i++) {
        if (array[i].uom_id === null) {
          this.alert.push('Stock <strong>[' + array[i].product_no + ']</strong> Uom tidak boleh kosong')
        }
        if (parseFloat(array[i].qty_done) === 0) {
          this.alert.push('Stock <strong>[' + array[i].product_no + ']</strong> Qty tidak boleh kosong')
        }
        if (array[i].product_no === null) {
          this.alert.push('<strong>Product</strong> tidak boleh kosong')
        }
      }
    },
    async saveInventory () {
      await this.validate()
      if (this.alert.length > 0) {
        await this.$swal('Error', 'Data tidak valid, cek terlebih dahulu', 'error')
        return false
      }
      this.$Progress.start()
      this.loader.isLoading = true
      var inv = this.inventory
      var detail = []
      var array = this.inventory.details
      var total = 0
      for (let i = 0; i < array.length; i++) {
        if (inv.type_id === 'adjust_decrease' || inv.type_id === 'adjust_manufacture_decrease') {
          total = 0 - array[i].qty_done
        } else {
          total = array[i].qty_done
        }
        var rfinish = parseInt(array[i].qty_demand) === parseInt(array[i].qty_done) ? 'true' : 'false'
        const cost = array[i].cost.replace(/\./g, '')
        var obj = {
          id: array[i].id,
          inventory_no: array[i].inventory_no,
          serial_number: array[i].serial_number,
          sec_serial_number: array[i].sec_serial_number,
          product_no: array[i].product_no,
          product_sku: array[i].product_sku,
          warehouse_no: array[i].warehouse_no,
          uom_id: array[i].uom_id,
          qty_demand: array[i].qty_demand,
          qty_done: total,
          inventory_date: array[i].inventory_date,
          branch_no: array[i].branch_no,
          expired_date: array[i].expired_date,
          internal_no: array[i].internal_no,
          cost: parseFloat(cost.replace(',', '.')),
          vendor_no: array[i].vendor_no,
          receive_finish: rfinish
        }
        detail.push(obj)
      }
      var data = {
        id: inv.id,
        inventory_no: inv.inventory_no,
        type_id: inv.type_id,
        inventory_date: inv.inventory_date,
        notes: inv.notes,
        purchasing_no: inv.purchasing_no,
        warehouse_no: inv.warehouse_no,
        company_no: inv.company_no,
        branch_no: inv.branch_no,
        ext_no: inv.ext_no,
        status: 'approve',
        user_id: inv.user_id,
        user_approve: inv.user_approve,
        lock: true,
        ext_no2: inv.ext_no2,
        vendor_no: inv.vendor_no,
        details: detail,
        purchasing: inv.purchasing
      }
      var resp = {
        error: false,
        message: null
      }
      var invID = null
      console.log(data)
      await axios.post(inventoryUrl, data, { headers: getHeader(), timeout: process.env.VUE_APP_TIMEOUT })
        .then(response => {
          resp.error = false
          resp.message = response.data.message
          invID = response.data.data.id
        })
        .catch(error => {
          console.log(error.response)
          this.$swal('Error', error.response.data.message, 'error')
          throw error
        })
      await this.$emit('backParentID', invID)
      await this.$Progress.finish()
      this.loader.isLoading = false
      await this.$swal('Adjust', 'Process HPP & Journal?', 'success')
      await this.$Progress.start()
      this.loader.isLoading = true
      await this.setCOGSAll('no reply')
      await this.setJournalAdjust('no reply')
      if (resp.error === false) {
        await this.$Progress.finish()
        this.loader.isLoading = false
        await this.$swal('Success', resp.message, 'success')
        this.$emit('backSaveClicked')
      }
    },
    saveDraft: function () {
      axios.post(inventoryUrl, this.inventory, { headers: getHeader(), timeout: process.env.VUE_APP_TIMEOUT })
        .then(response => {
          this.$swal(
            'Success',
            response.data.message,
            'success'
          )
        })
        .catch(error => {
          console.log(error.response)
          this.$swal(
            'Error',
            error.response.data.message,
            'error'
          )
        })
    },
    async updateInventory (reply) {
      await this.validate()
      if (this.alert.length > 0) {
        await this.$swal('Error', 'Data tidak valid, cek terlebih dahulu', 'error')
        return false
      }
      await this.$Progress.start()
      this.loader.isLoading = true
      var inv = this.inventory
      var detail = []
      var array = this.inventory.details
      var total = 0
      for (let i = 0; i < array.length; i++) {
        if (inv.type_id === 'adjust_decrease' || inv.type_id === 'adjust_manufacture_decrease') {
          if (array[i].qty_done > 0) {
            total = 0 - array[i].qty_done
          } else {
            total = array[i].qty_done
          }
        } else {
          total = array[i].qty_done
        }
        var rfinish = parseInt(array[i].qty_demand) === parseInt(array[i].qty_done) ? 'true' : 'false'
        const cost = array[i].cost.replace(/\./g, '')
        var obj = {
          id: array[i].id,
          inventory_no: array[i].inventory_no,
          serial_number: array[i].serial_number,
          sec_serial_number: array[i].sec_serial_number,
          product_no: array[i].product_no,
          product_sku: array[i].product_sku,
          warehouse_no: array[i].warehouse_no,
          uom_id: array[i].uom_id,
          qty_demand: array[i].qty_demand,
          qty_done: total,
          inventory_date: array[i].inventory_date,
          branch_no: array[i].branch_no,
          expired_date: array[i].expired_date,
          internal_no: array[i].internal_no,
          cost: parseFloat(cost.replace(',', '.')),
          vendor_no: array[i].vendor_no,
          receive_finish: rfinish
        }
        detail.push(obj)
      }
      var data = {
        id: inv.id,
        inventory_no: inv.inventory_no,
        type_id: inv.type_id,
        inventory_date: inv.inventory_date,
        notes: inv.notes,
        purchasing_no: inv.purchasing_no,
        warehouse_no: inv.warehouse_no,
        company_no: inv.company_no,
        branch_no: inv.branch_no,
        ext_no: inv.ext_no,
        status: 'approved',
        user_id: inv.user_id,
        user_approve: inv.user_approve,
        lock: true,
        ext_no2: inv.ext_no2,
        vendor_no: inv.vendor_no,
        details: detail,
        purchasing: inv.purchasing
      }
      var invID = null
      await axios.put(inventoryUrl + '/' + this.inventory.id, data, { headers: getHeader(), timeout: process.env.VUE_APP_TIMEOUT })
        .then(response => {
          console.log(response.data.message)
          invID = response.data.data.id
        })
        .catch(error => {
          console.log(error.response)
          this.$swal('Error', error.response.data.message, 'error')
          throw error
        })
      await this.$emit('backParentID', invID)
      await this.$Progress.finish()
      this.loader.isLoading = false
      await this.$swal('Adjust', 'Process HPP & Journal?', 'success')
      await this.$Progress.start()
      this.loader.isLoading = true
      await this.setCOGSAll('no reply')
      await this.setJournalAdjust('no reply')
      await this.$Progress.finish()
      this.loader.isLoading = false
      if (reply === 'reply') {
        await this.$swal('Success', 'Success update inventory adjust', 'success')
        this.$emit('backSaveClicked')
      }
    },
    updateDraftInventory: function () {
      axios.put(inventoryUrl + '/' + this.inventory.id, this.inventory, { headers: getHeader(), timeout: process.env.VUE_APP_TIMEOUT })
        .then(response => {
          this.$swal(
            'Success',
            response.data.message,
            'success'
          )
        })
        .catch(error => {
          console.log(error.response)
          this.$swal(
            'Error',
            '<pre>' + error.response.data.message + '</pre>',
            'error'
          )
        })
    },
    addBarcode: function (id) {
      this.idPDetail = id
      var pDetail = this.purchasing.details.find(d => d.id === id)
      var uom = this.uomList.find(d => d.id === pDetail.uom_id)
      var newUom = this.uomList.find(d => {
        if (d.type_id === uom.type_id && d.category_id === 3) {
          return d
        }
      })
      var ind = this.inventory.details.find(d => d.id === null)
      /* eslint-disable */
      var newID = Math.floor(Math.random() * (9999999999 - 666666666666) + 666666666666)
      if (ind) {
        ind.id = newID,
        ind.product_no = pDetail.product_no
        ind.product = pDetail.product
        ind.uom_id = newUom.id
        ind.qty_done = 1
      } else {
        if (pDetail.canBarcode === false) {
          const inv = this.inventory.details.filter(p => p.product_no === pDetail.product_no)
          if (inv.length < 1){
            var obj = {
              id: newID,
              inventory_no: null,
              qty_demand: null,
              qty_done: 1,
              serial_number: null,
              product_no: pDetail.product_no,
              product: pDetail.product,
              canBarcode: pDetail.canBarcode,
              warehouse_no: null,
              uom_id: newUom.id
            }
            // this.inventory.detail.push(obj)
          }
        } else {
          var obj = {
            id: newID,
            inventory_no: null,
            qty_demand: null,
            qty_done: 1,
            serial_number: null,
            product_no: pDetail.product_no,
            product: pDetail.product,
            canBarcode: pDetail.canBarcode,
            warehouse_no: null,
            uom_id: newUom.id
          }
          // this.inventory.detail.push(obj)
        }
      }
      this.product = {
        product_no: pDetail.product_no,
        uom_id: newUom.id
      }
    },
    backParent: function () {
      this.$emit('backClicked')
    },
    saveBarcode: function (value) {
      var pd = this.purchasing.details.find(d => d.id === value.idPDetail)
      pd.qty_done = value.qty_done
      console.log(value)
      console.log(pd)
    }
  }
}
</script>

<style>
.flex {
  display: flex;
  flex-direction: row;
}
</style>